import { LimitRow } from '@widgets/card/limitRow/limitRow';
import { BaseInput } from '@shared/widgets';

const validPattern = /^\d*\.?\d{0,2}$/;

interface CardNewLimitRowProps {
  limitRowLabel: string;
  currentAmount: number;
  limitAmount: number;
  limitNumber: number;
  currentNumber: number;
  symbol?: string;
  firstInputLabel: string;
  firstInputValue: string | number;
  firstInputOnChange: (value: string) => void;
  firstInputLimitValue?: number;
  secondInputLabel: string;
  secondInputValue: string | number;
  secondInputOnChange: (value: string) => void;
  secondInputLimitValue?: number;
}

export const CardNewLimitRow = (props: CardNewLimitRowProps) => {
  return (
    <div className='mb-5 w-72 max-w-full px-5'>
      <LimitRow
        label={props.limitRowLabel}
        currentAmount={props.currentAmount}
        limitAmount={props.limitAmount}
        limitNumber={props.limitNumber}
        currentNumber={props.currentNumber}
        symbol={props.symbol}
      />

      <div className='mt-3'>
        <BaseInput
          type='number'
          placeholder={props.firstInputLabel}
          value={props.firstInputValue as string}
          onChange={(value) => {
            if (validPattern.test(value)) props.firstInputOnChange(value);
          }}
        />
      </div>
      <div className='mt-3'>
        <BaseInput type='number' placeholder={props.secondInputLabel} value={props.secondInputValue as string} onChange={props.secondInputOnChange} />
      </div>
    </div>
  );
};
